import httpClient from '@/services/http/httpClient'

export const apiPostFurniture = ({ sinisterId, claimId, secondaryId, kindOfProperty, latitude, longitude, zipCode, propertyType, residentType, moreThanTwoYears, externalDamageId }) => {
  // todo err
  if (!sinisterId || !claimId) return Promise.reject(new Error('err'))

  const params = {
    sinister_id: sinisterId,
    claim_id: claimId,
    KIND_OF_PROPERTY: kindOfProperty,
    lat: latitude,
    lon: longitude,
    zip_code: zipCode,
    real_estate: propertyType,
    declarant: residentType,
    more_than_two_years: moreThanTwoYears
  }

  if (secondaryId) params.complementary_ref = secondaryId
  if (externalDamageId) params.external_damage_id = externalDamageId

  return httpClient.post('furniture/', params)
    .then(data => data)
    .catch(error => Promise.reject(error))
}

export const apiGetUpptecToken = () => {
  return httpClient.get('furniture/upptec/login')
    .then(data => data)
    .catch(error => Promise.reject(error))
}
